namespace advisorop.components.servicer {
    
    export class CuManagerProductTypeController {

        managerId: number;
        onProductTypesChange: any;

        dgManagerProductTypes: DevExpress.ui.dxDataGridOptions;
        productTypeSelected: boolean = false;
        servicer: any;
        advisoryFirmId: number;
        manager: domains.IManager = {};
        managerProductType: domains.IManagerProductType = {};
        lovs: Array<domains.ILOV> = [];
        productTypes: Array<domains.ILOV> = [];
        selProductType: domains.ILOV;
        managerProductTypes: Array<domains.IManagerProductType> = [];
        
        showProductTypePanel: boolean = false;

        static $inject = ["servicerService", "generalService"];
        constructor(private servicerService: services.ServicerService,
            private generalService: services.GeneralService)
        {
            this.dgManagerProductTypes = {
                export: {
                    enabled: true,
                    fileName: "ManagerProductTypes"
                },
                bindingOptions: {
                    dataSource: "vm.managerProductTypes",
                    "columns[0].lookup.dataSource": "vm.productTypes"
                },
                paging: { pageSize: 5 },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: false,
                allowColumnReordering: false,
                noDataText: "There are no managers products",
                allowColumnResizing: false,
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: true },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: true,
                    width: 240,
                    placeholder: "Search..."
                },
                wordWrapEnabled: true,
                columns: [
                    { dataField: "productTypeId", caption: "Product Type", lookup: { dataSource: this.productTypes, valueExpr: "value", displayExpr: "name" } },
                    { dataField: "contactFirstName", caption: "First Name"},
                    { dataField: "contactLastName", caption: "Last Name"},
                    { dataField: "contactAddress", caption: "Address" },
                    { dataField: "statusDescription", caption: "Status" },
                    { dataField: "id", caption: "Actions", cellTemplate: "btnActions", width: "175" }
                ]
            };
        }
        
        productTypeChanged(): void {
            this.managerProductType.productTypeId = this.selProductType.value;
        }

        cancel() {
            this.selProductType = null;
            this.showProductTypePanel = false;
            this.managerProductType = {};
        };
        
        addManagerProductType(): void {

            this.managerProductType.productTypeId = this.selProductType.value;

            this.managerProductType.managerId = this.managerId;
            
            this.servicerService.createManagerProductType(this.managerProductType)
                .then( response => {

                    toastr.success("Product Type has been successfully assigned to Manager");

                    this.managerProductTypes.push(response.data);

                    this.onProductTypesChange({ managerProductType: response.data });

                    // close product type panel
                    this.cancel();
                })
                .catch(err => {
                    toastr.error("Product Type has not been assigned to Manager. " + err.data);
                })
        };

        setManagerProductTypeStatus(managerProductType: domains.IManagerProductType) {

            let managerProductTypeStatus: domains.Status;

            if (managerProductType.status == domains.Status.ACTIVE)
                managerProductTypeStatus = domains.Status.INACTIVE;
            else {
                managerProductTypeStatus = domains.Status.ACTIVE;
            }

            this.servicerService.setManagerProductTypeStatus(managerProductType, managerProductTypeStatus)
                .then(response => {
                    //var ind = this.firmProducts.indexOf(advisoryFirmProduct);
                    //if (ind >= 0) {
                    //    this.firmProducts.splice(ind, 1);
                    //}
                    toastr.success("Manager product type status successfully changed");
                    this.loadManagerProductTypes(this.managerId);
                }, err => toastr.error("Manager product type status has not been changed. " + err.data));
        };


        newManagerProductType(): void {
            this.selProductType = null;
            this.managerProductType = {};
            this.showProductTypePanel = true;
        };

        editManagerProductType(managerProductType: domains.IManagerProductType): void {
            this.managerProductType = managerProductType;
            this.selProductType = this.productTypes.filter(v => { return v.value === this.managerProductType.productTypeId; })[0];
            this.showProductTypePanel = true;
        };
        
        updateManagerProductType(): void {

            this.servicerService.updateManagerProductType(this.managerProductType)
                .then(response => {
                    toastr.success("Manager Product Type contact details have been updated successfully.");

                    this.managerProductType = response.data;

                    this.loadManagerProductTypes(this.managerId);

                    this.onProductTypesChange({ managerProductType: response.data });
                })
                .catch(err => {
                    toastr.error("Unable to change Product Type. " + err.data);
                });
        };

        deleteManagerProductType(managerProductType: domains.IManagerProductType): void {
            if (!window.confirm("Are you sure ?"))
                return;

            var x = this.managerProductTypes;

            this.servicerService.deleteManagerProductType(managerProductType.id)
                .then((response) => {

                    toastr.success("Manager Product Type has been successfully deleted");

                    var ind = x.indexOf(managerProductType);
                    if (ind >= 0) {
                        x.splice(ind, 1);
                    }
                    this.loadManagerProductTypes(this.managerId);
                }).
                catch(err => {
                    toastr.error("Manager Product Type has not been deleted. " + err.data);
                });
        };
        
        loadManagerProductTypes(managerId: number): void {
            
            this.servicerService.getManagerProductTypes(managerId)
                .then((response) => {
                    this.managerProductTypes = response.data;
                    //console.log(this.managerProductTypes);
                })
                .catch(err => {
                    toastr.error("Cannot fetch Product Types. " + err.data);
                });
        };
        
        loadLovs(): void {
            this.generalService.getLOVs()
                .then( data => {
                    this.productTypes = data.filter((value, index, array) => { return value.lovType == domains.LovType.PRODUCT_TYPE; });
                }, err => {
                    toastr.error("Cannot load Product Types. " + err.data);
                });
        };
        


        $onInit(): void {
            this.loadLovs();
        }

        $onChanges(evt): void {
            for (var key in evt) {
                if (key === "managerId") {
                    if (this.managerId > 0) {
                        //this.getManagerById(this.managerId);
                        this.loadManagerProductTypes(this.managerId);
                    }
                }
            }
        }
    }


    class CuManagerProductTypes implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                managerId: "<",
                onProductTypesChange: "&"
            };
            this.controller = CuManagerProductTypeController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/servicer-module/components/cu-manager-product-types.html";
        }
    }
    angular.module(Constants.APP).component("cuManagerProductTypes", new CuManagerProductTypes());
}